<template>
  <div class="form-floating flex-grow-1 mb-3">
    <select
      class="form-select col-3"
      :class="{ 'is-invalid': errors }"
      :name="name"
      :value="value ? value : options[0].value"
      :data-attribute="attribute"
      @change="$emit('update:data', $event)"
    >
      <option v-for="(option, index) in options" :key="index" :value="option.value">
        {{ option.text }}
      </option>
    </select>
    <div v-for="(error, index) in errors" :key="index" class="invalid-feedback" role="alert">
      <strong>{{ error }}</strong>
    </div>
    <label :for="name">{{ label }} </label>
  </div>
</template>

<script>
export default {
  props: {
    attribute: {
      type: String,
      default: null,
    },
    errors: {
      type: Array,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
  },
  emits: ['update:data'],
  setup(props) {
    const selectedOption = (option) => {
      if (option === props.value) return true;
      return false;
    };

    return { selectedOption };
  },
};
</script>
